import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCompass, FiMail, FiTwitter, FiLinkedin } = FiIcons;

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container mx-auto px-6 py-12">
        <div className="footer-content">
          <motion.div 
            className="footer-brand"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="footer-logo">
              <SafeIcon icon={FiCompass} className="logo-icon" />
              <span className="logo-text">MindFlow</span>
            </div>
            <p className="footer-tagline">
              Built for brains that think different.
            </p>
            <div className="social-links">
              <a href="mailto:hello@mindflow.app" className="social-link">
                <SafeIcon icon={FiMail} />
              </a>
              <a href="https://twitter.com/mindflow" className="social-link">
                <SafeIcon icon={FiTwitter} />
              </a>
              <a href="https://linkedin.com/company/mindflow" className="social-link">
                <SafeIcon icon={FiLinkedin} />
              </a>
            </div>
          </motion.div>
          
          <motion.div 
            className="footer-info"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <p className="footer-note">
              MindFlow is currently in development. We're building something 
              special for neurodivergent founders, creatives, and multi-hyphenated 
              humans who are tired of productivity tools that don't understand 
              how their brilliant brains actually work.
            </p>
            
            <div className="footer-links">
              <a href="#privacy" className="footer-link">Privacy Policy</a>
              <a href="#terms" className="footer-link">Terms of Service</a>
              <a href="mailto:hello@mindflow.app" className="footer-link">Contact</a>
            </div>
          </motion.div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 MindFlow. Made with ❤️ for brilliant, neurodivergent minds.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;